<template>
  <div class="area-cascader">
    <el-select class="area-select" v-model="modelProvince" @change="getIsArea('cities', modelProvince)" size="small" :disabled="isArea.province&&isAdmin">
      <el-option
        v-for="item in provinces"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select class="area-select" v-model="modelCity" @change="getIsArea('counties', modelCity)" size="small" :disabled="isArea.city&&isAdmin">
      <el-option
        v-for="item in cities"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select class="area-select" v-model="modelCounty" size="small" :disabled="isArea.county&&isAdmin">
      <el-option
        v-for="item in counties"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>
<script type="text/ecmascript-6">
  import { getAreaList } from '@/api/enum'
  export default {
    name: 'LyAreaCascader',
    data() {
      return {
        provinces: [],
        cities: [],
        counties: [],
        modelProvince: null,
        modelCity: null,
        modelCounty: null,
        isArea: {
          province: false,
          city: false,
          county: false
        },
        isdemo: false
      }
    },
    props: {
      province: {
        type: String,
        default: null
      },
      city: {
        type: String,
        default: null
      },
      county: {
        type: String,
        default: null
      },
      isAdmin: { // admin是否可修改区域
        type: Boolean,
        default: false
      },
      isCascade: { // 是否与机构联动
        type: Boolean,
        default: false
      },
      orgArea: { // 关联机构区域
        type: Object,
        default: {
          province: null,
          city: null,
          county: null
        }
      }
    },
    computed: {
      isAdd() {
        return this.isAdmin&&this.isCascade;
      }
    },
    created() {
      this.modelProvince = this.province;
      this.modelCity = this.city;
      this.modelCounty = this.county;
      this.getAreaDisable(this.orgArea, this.isArea);
      this.initProvinces();
    },
    methods: {
      getAreaDisable(orgArea,isArea) {
        for (var i in orgArea) {
          if (orgArea[i] != null) {
            isArea[i] = true;
          } else {
            isArea[i] = false;
          }
        }
      },
      initProvinces(areaId = 0) {
        getAreaList({areaId}).then(response => {
          this.provinces = response.data;
        });
      },
      defalutArea(model, val) {
        this[model] = val ? val : null;
      },
      getArea(id, fun) {
        getAreaList({areaId: id}).then(response => {
          response.data.sort(function (a,b) {
            return a.id - b.id;
          });
          fun(response);
        });
      },
      getIsArea(name, id) {
        const vm = this;
        if (name === 'cities' && id == null) {
          vm.cities = [];
          vm.counties = [];
          return;
        } else if (name === 'counties' && id == null) {
          vm.counties = [];
          return;
        }
        if (id) {
          this.getArea(id || 0, function(response) {
            vm[name] = response.data;
          });
        }
        this.$emit('areaCascader', {province: vm.modelProvince, city: vm.modelCity, county: vm.modelCounty});
      }
    },
    watch: {
      modelProvince(val) {
        this.getIsArea('cities', val);
        this.isCascade ? this.modelCity = null : '';
      },
      modelCity(val) {
        this.getIsArea('counties', val);
        this.isCascade ? this.modelCounty = null : '';
        this.counties = [];
      },
      modelCounty(newV, oldV) {
        const vm = this;
        this.$emit('areaCascader', {province: vm.modelProvince, city: vm.modelCity, county: this.isCascade?oldV:newV});
      },
      province(val) {
        this.defalutArea('modelProvince', val);
      },
      city(val) {
        this.defalutArea('modelCity', val);
      },
      county(val) {
        this.defalutArea('modelCounty', val);
      },
      orgArea(val) {
        this.getAreaDisable(val, this.isArea);
      }
    }
  }
</script>
<style>
    .area-cascader {
        display: block;
    }
    .area-select {
        display: inline-block;
        width: 32.4%;
    }
</style>



// WEBPACK FOOTER //
// src/components/area-cascader/index.vue